import React from 'react';
import {Tab, Tabs} from "react-bootstrap";
import StyledDropzone, {DROPZONE_PDF_TYPE, DROPZONE_WEBSITE_TYPE} from "../StyledDropzone";
import TemplateSelector from "../TemplateSelector/TemplateSelector";

const contentTypes = {
  resume: 'pdf',
  pdf: 'pdf',
  html: 'html',
  template: 'template'
}

export const HTML_TYPE = 'HTML_TYPE';
export const ALL_TYPES = 'ALL_TYPES';

const getContentTypes = (type, defaultKey, onDrop, onTemplateSelected) => {
  if (type === ALL_TYPES) {
    return <Tabs
      id="content-selector"
      defaultActiveKey={defaultKey}
      className="mb-3 justify-center"
    >
      <Tab eventKey="html" title="HTML">
        <StyledDropzone
          className="tr-landing-upload-file-zone"
          onDrop={onDrop}
          onTemplateSelected={onTemplateSelected}
          type={DROPZONE_WEBSITE_TYPE}
        />
      </Tab>
      <Tab eventKey="zip" title="ZIP" className="tr-zip-tab">
        <StyledDropzone
          className="tr-landing-upload-file-zone"
          onDrop={onDrop}
          onTemplateSelected={onTemplateSelected}
          type="ZIP"
        />
      </Tab>
      <Tab eventKey="pdf" title="PDF" className="tr-pdf-tab">
        <StyledDropzone
          className="tr-landing-upload-file-zone"
          onDrop={onDrop}
          onTemplateSelected={onTemplateSelected}
          type={DROPZONE_PDF_TYPE}
        />
      </Tab>
      <Tab eventKey="template" title="Examples" className="tr-templates-tab">
        <TemplateSelector
          onClick={onTemplateSelected}
        />
      </Tab>
    </Tabs>
  } else if (type === HTML_TYPE) {
    return <StyledDropzone
      className="tr-landing-upload-file-zone"
      onDrop={onDrop}
      onTemplateSelected={onTemplateSelected}
      hideTemplate
    />
  }
}

const ContentSelector = ({ className, onDrop, onTemplateSelected, type = ALL_TYPES }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const defaultKey = contentTypes[urlParams.get('content')] || 'html';

  return <div className={`container-dropzone ${className || ''}`}>
    {getContentTypes(type, defaultKey, onDrop, onTemplateSelected)}
  </div>;
}

export default ContentSelector;